import i18n from '@/langs/i18n.js';

export default [
  {
    text: i18n.t('credit.creditExpert'),
    value: 'EXPERT'
  },
  {
    text: i18n.t('credit.creditAdvisor'),
    value: 'ADVISER'
  },
  {
    text: i18n.t('credit.insuranceAgent'),
    value: 'AGENT'
  },
  {
    text: i18n.t('credit.bankEmployee'),
    value: 'REPRESENTATIVE'
  }
]
